import { pipe } from 'fp-ts/function';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { ConnectedEditDialogForm, formValuesSelector } from '@mews-commander/legacy-form';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Stack } from '@optimus-web/core';
import { closeDialog } from '../../../../modules/dialog/reducer';
import { isDialogOpen } from '../../../../modules/dialog/selectors';
import { SendEmailType } from './Action/SendFinancialDocumentToEmailAction';
import RepeatedPrintDialogForm, { EmailPrintFormValues, formName, PrintFormValues } from './RepeatedPrintDialogForm';

const repeatedPrintFormValuesSelector = formValuesSelector<PrintFormValues | EmailPrintFormValues>;

interface DispatchProps {
    onClose: () => void;
}

interface StateProps {
    active: boolean;
    repeatedPrintFormState: PrintFormValues | EmailPrintFormValues;
    type: SendEmailType;
}

type RepeatedPrintDialogProps = DispatchProps & StateProps;

const RepeatedPrintDialog = ({ onClose, active, repeatedPrintFormState, type }: RepeatedPrintDialogProps) => (
    <ConnectedEditDialogForm
        active={active}
        formName={formName}
        primaryButtonTextKey={TextKey.Print}
        closeDialog={onClose}
        title={<LocalizedText textKey={TextKey.RepeatedPrint} />}
    >
        <Stack spacing="200" vertical>
            <Banner
                variant="info"
                primaryText={<LocalizedText textKey={TextKey.SelectedTemplateDifferentThanOriginal} />}
                secondaryText={
                    <LocalizedText
                        textKey={TextKey.DescriptionForReprintReason}
                        substitutes={{ firstTemplate: repeatedPrintFormState?.firstUsedTemplateType }}
                    />
                }
            />
            <RepeatedPrintDialogForm type={type} />
        </Stack>
    </ConnectedEditDialogForm>
);

export default pipe(
    RepeatedPrintDialog,
    connect<StateProps, DispatchProps, {}, ApplicationState>(
        (state: ApplicationState) => ({
            active: isDialogOpen(state, { name: formName }),
            repeatedPrintFormState: repeatedPrintFormValuesSelector(state, { form: formName }),
            type: formValueSelector(formName)(state, 'type'),
        }),
        (dispatch) => ({
            onClose: () => dispatch(closeDialog(formName)),
        })
    )
);
